import React, { useEffect, useState } from 'react';

const AdminUserList = ({ API_BASE_URL }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState('');

    useEffect(() => { fetchData(); }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('admin_token');
            const res = await fetch(`${API_BASE_URL}/api/admin/users`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const json = await res.json();
            if (json.success) setData(json.data || []);
        } catch (e) { console.error(e); }
        finally { setLoading(false); }
    };

    const filtered = data.filter((r) =>
        r.GROUP_ID?.toLowerCase().includes(filter.toLowerCase()) ||
        r.USER_ID?.toLowerCase().includes(filter.toLowerCase()) ||
        r.USER_NAME?.toLowerCase().includes(filter.toLowerCase())
    );

    return (
        <div style={S.wrap}>
            <div style={S.toolbar}>
                <h2 style={S.title}>사용자 조회</h2>
                <input
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    placeholder="업체코드/아이디/이름 검색..."
                    style={S.searchInput}
                />
            </div>
            {loading ? (
                <div style={S.loading}>불러오는 중...</div>
            ) : (
                <div style={S.tableWrap}>
                    <table style={S.table}>
                        <thead>
                            <tr>
                                <th style={S.th}>#</th>
                                <th style={S.th}>업체코드</th>
                                <th style={S.th}>사용자 ID</th>
                                <th style={S.th}>이름</th>
                                <th style={S.th}>관리자</th>
                                <th style={S.th}>등록일</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.length === 0 ? (
                                <tr><td colSpan={6} style={S.emptyTd}>데이터가 없습니다</td></tr>
                            ) : filtered.map((row, i) => (
                                <tr key={i} style={i % 2 === 0 ? {} : { background: '#f9fafb' }}>
                                    <td style={S.td}>{i + 1}</td>
                                    <td style={S.td}>{row.GROUP_ID}</td>
                                    <td style={S.td}>{row.USER_ID}</td>
                                    <td style={S.td}>{row.USER_NAME || '-'}</td>
                                    <td style={S.td}>{row.MANAGER_YN === 'Y' ? '✓' : ''}</td>
                                    <td style={S.td}>{row.REG_DT ? new Date(row.REG_DT).toLocaleDateString('ko-KR') : '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

const S = {
    wrap: { padding: '20px', height: '100%', display: 'flex', flexDirection: 'column' },
    toolbar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' },
    title: { fontSize: '18px', fontWeight: '700', color: '#1f2937' },
    searchInput: {
        padding: '8px 12px', border: '1px solid #e5e7eb', borderRadius: '8px',
        fontSize: '14px', width: '280px', outline: 'none',
    },
    loading: { textAlign: 'center', padding: '40px', color: '#6b7280' },
    tableWrap: { flex: 1, overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: '8px' },
    table: { width: '100%', borderCollapse: 'collapse', fontSize: '14px' },
    th: {
        padding: '10px 14px', background: '#f8fafc', borderBottom: '2px solid #e5e7eb',
        textAlign: 'center', fontWeight: '600', color: '#374151', position: 'sticky', top: 0,
    },
    td: { padding: '8px 14px', borderBottom: '1px solid #f3f4f6', textAlign: 'center', color: '#4b5563' },
    emptyTd: { padding: '40px', textAlign: 'center', color: '#9ca3af' },
};

export default AdminUserList;
